if (!customElements.get('grid-bundle-card')) customElements.define('grid-bundle-card', class extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-grid-bundle-submit]')?.addEventListener('click', () => this.addBundle());
    this.querySelectorAll('.grid-bundle-card__select-wrap').forEach((wrap) => {
      const select = wrap.querySelector('[data-grid-bundle-variant]');
      const toggle = wrap.querySelector('[data-grid-variant-toggle]');
      const list = wrap.querySelector('.grid-bundle-card__variant-list');
      toggle?.addEventListener('click', () => this.toggleDropdown(wrap));
      list?.addEventListener('wheel', (event) => event.stopPropagation(), { passive: true });
      list?.addEventListener('touchmove', (event) => event.stopPropagation(), { passive: true });
      wrap.querySelectorAll('[data-grid-variant-option]').forEach((option) => option.addEventListener('click', () => {
        select.value = option.dataset.value;
        wrap.querySelectorAll('[data-grid-variant-option]').forEach((item) => item.setAttribute('aria-selected', String(item === option)));
        const name = wrap.querySelector('.grid-bundle-card__selected-name');
        const image = wrap.querySelector('.grid-bundle-card__thumb');
        if (name) name.textContent = option.dataset.label || '';
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = option.dataset.image;
          image.alt = option.dataset.label || '';
          image.hidden = false;
        }
        this.closeDropdown(wrap);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    });
    this._outside = (event) => {
      if (!this.contains(event.target)) this.querySelectorAll('.grid-bundle-card__select-wrap.is-open').forEach((wrap) => this.closeDropdown(wrap));
    };
    document.addEventListener('click', this._outside);
  }
  disconnectedCallback() { document.removeEventListener('click', this._outside); }
  toggleDropdown(wrap) {
    const open = !wrap.classList.contains('is-open');
    this.querySelectorAll('.grid-bundle-card__select-wrap.is-open').forEach((item) => this.closeDropdown(item));
    if (open) {
      wrap.classList.add('is-open');
      wrap.querySelector('[data-grid-variant-toggle]')?.setAttribute('aria-expanded', 'true');
      const list = wrap.querySelector('.grid-bundle-card__variant-list');
      if (list) {
        list.querySelectorAll('img[data-src]').forEach((image) => {
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
        });
        list.hidden = false;
      }
    }
  }
  closeDropdown(wrap) {
    wrap.classList.remove('is-open');
    wrap.querySelector('[data-grid-variant-toggle]')?.setAttribute('aria-expanded', 'false');
    const list = wrap.querySelector('.grid-bundle-card__variant-list');
    if (list) list.hidden = true;
  }
  async addBundle() {
    const button = this.querySelector('[data-grid-bundle-submit]');
    const status = this.querySelector('[data-grid-bundle-status]');
    const ids = [...this.querySelectorAll('[data-grid-bundle-variant]')].map((select) => select.value).filter(Boolean);
    if (ids.length !== 3) return;
    button.disabled = true;
    button.dataset.cartPending = 'true';
    status.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      for (const id of ids) {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: 1 }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);
      }
      status.textContent = '';
      const opened = await window.refreshAndOpenCartDrawer?.(button);
      if (!opened) window.location.assign(root + 'cart');
      button.disabled = false;
    } catch (error) {
      status.textContent = error.message || window.gridBundleStrings?.error || 'Could not add to cart';
      button.disabled = false;
      button.removeAttribute('data-cart-pending');
    }
  }
});
